__turbopack_context__.v({
  "btnWrapper": "shopify-products-module___SxZ9a__btnWrapper",
  "card": "shopify-products-module___SxZ9a__card",
  "ecmrce": "shopify-products-module___SxZ9a__ecmrce",
  "grid": "shopify-products-module___SxZ9a__grid",
  "guide": "shopify-products-module___SxZ9a__guide",
  "productImage": "shopify-products-module___SxZ9a__productImage",
  "title": "shopify-products-module___SxZ9a__title",
});
